import { Nullable } from '@internal-libraries/kheops-ui-lib'
import { AdmissionTypeData, AdmissionTypeDto } from '../Type'

export default class ClvrAdmissionType {
    public id: Nullable<number> = null
    public label = ''

    public constructor(data: AdmissionTypeData) {
        this.id = data.id ?? null
        this.label = data.label ?? ''
    }

    public toDto(): AdmissionTypeDto {
        return {
            id: this.id,
            label: this.label,
        }
    }
}
